import { createReducer } from '@common/redux-utils';

import {
  CheckBoxAction,
  CheckDateAction,
  CheckSignatureAction,
  CILNotificationCILActionType,
  GotoPageAction,
  LeaveAction
} from './cil.actions';
import { CILNotificationCILComponentPage } from './_components/cil.component';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface CILNotificationCILState {
  checkboxCount: number;
  date?: Date;
  hasInvalidDate: boolean;
  hasSignature: boolean;
  hasValidDate: boolean;
  isSubmitEnabled: boolean;
  page: CILNotificationCILComponentPage;
}

// This is the initial state of the page
export const cilNotificationCILInitialState: CILNotificationCILState = {
  checkboxCount: 0,
  hasInvalidDate: false,
  hasSignature: false,
  hasValidDate: false,
  isSubmitEnabled: false,
  page: CILNotificationCILComponentPage.CIL
};

const CHECKBOX_COUNT = 3;

function handleCheckBox(state: CILNotificationCILState, action: CheckBoxAction): CILNotificationCILState {
  let checkboxCount: number = state.checkboxCount + 1;
  return {
    ...state,
    checkboxCount: checkboxCount,
    isSubmitEnabled: checkboxCount >= CHECKBOX_COUNT && state.hasSignature && state.hasValidDate
  };
}

function handleCheckDate(state: CILNotificationCILState, action: CheckDateAction): CILNotificationCILState {
  let hasValidDate: boolean = false;
  if (action.date) {
    const now: Date = new Date(Date.now());
    hasValidDate =
      action.date.getFullYear() === now.getFullYear() &&
      action.date.getMonth() === now.getMonth() &&
      action.date.getDate() === now.getDate();
  }
  return {
    ...state,
    date: action.date,
    hasInvalidDate: !hasValidDate,
    hasValidDate: hasValidDate,
    isSubmitEnabled: state.checkboxCount >= CHECKBOX_COUNT && state.hasSignature && hasValidDate
  };
}

function handleCheckSignature(state: CILNotificationCILState, action: CheckSignatureAction): CILNotificationCILState {
  let hasSignature: boolean = action.signature !== '';
  return {
    ...state,
    hasSignature: hasSignature,
    isSubmitEnabled: state.checkboxCount >= CHECKBOX_COUNT && hasSignature && state.hasValidDate
  };
}

function handleGotoPage(state: CILNotificationCILState, action: GotoPageAction): CILNotificationCILState {
  return {
    ...state,
    checkboxCount: 0,
    date: undefined,
    hasInvalidDate: false,
    hasValidDate: false,
    isSubmitEnabled: false,
    page: action.page
  };
}

function handleLeave(state: CILNotificationCILState, action: LeaveAction): CILNotificationCILState {
  return {
    ...state,
    checkboxCount: 0,
    date: undefined,
    hasInvalidDate: false,
    hasValidDate: false,
    isSubmitEnabled: false,
    page: CILNotificationCILComponentPage.CIL
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const CILNotificationCILReducer = createReducer(cilNotificationCILInitialState, {
  [CILNotificationCILActionType.CheckBox]: handleCheckBox,
  [CILNotificationCILActionType.CheckDate]: handleCheckDate,
  [CILNotificationCILActionType.CheckSignature]: handleCheckSignature,
  [CILNotificationCILActionType.GotoPage]: handleGotoPage,
  [CILNotificationCILActionType.Leave]: handleLeave
});



// WEBPACK FOOTER //
// ./src/cil-notification/_components/cil/cil.reducer.ts